import React from 'react';
import { NafLocationSlugs, useHandleNafLocationsRoutes } from '../../useHandleNafLocationsRoutes';
import { MonthWrapper, StyledGrid } from './EventList.styles';
import { EventListProps } from './EventList.types';
import MonthHeader from './MonthHeader';
import EventItem from './EventItem';
import EmptyState from './EmptyState';

const EventList = ({ monthlyEvents, noHitText, button }: EventListProps) => {
  const { locations } = useHandleNafLocationsRoutes();
  const eventsBaseUrl = locations[NafLocationSlugs.events].fullUrl;

  const hasNoEvents = monthlyEvents.length === 0;

  if (hasNoEvents) {
    return <EmptyState noHitText={noHitText} button={button} />;
  }

  return (
    <>
      {monthlyEvents.map(({ events, month }) => {
        const monthKey = `${month.month}-${month.year}`;

        return (
          <MonthWrapper key={monthKey}>
            <MonthHeader month={month} />
            <StyledGrid>
              {events.map((event) => {
                const eventUrl = `${eventsBaseUrl}/${event.link.data.slug}`;
                return <EventItem key={eventUrl} event={event} eventUrl={eventUrl} />;
              })}
            </StyledGrid>
          </MonthWrapper>
        );
      })}
    </>
  );
};

export default EventList;
